import { ArrowRight } from 'lucide-react'
import { PageMeta } from '../components/PageMeta'

export function NotFoundPage() {
  return (
    <main id="main-content" className="not-found-page section-dark">
      <PageMeta
        title="Page not found"
        description="The requested page could not be found on the Informat website."
      />
      <span>404</span>
      <h1>
        That page is not here.<span className="text-cursor" aria-hidden="true" />
      </h1>
      <p>The link may be outdated, or the address may have been entered incorrectly.</p>
      <a href="/">
        Return home <ArrowRight aria-hidden="true" />
      </a>
    </main>
  )
}
